module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"download-error":"Error ao baixar mídia. ","faces-error":"As faces desta mídia estão sendo processadas.","mobile-download":"Clique na mídia e segure, selecionando a opção para salvar no rolo de câmera."}}')
  delete Component.options._Ctor
}
